export default "/kiban/_next/static/images/manuOptPlanCad-e1608fbe4a51bf29eac78a133af57af2.png";